/**
 * @type function
 * @param {*} state
 * @param {string} dialogName
 */
export const dialogSelector = (state) => (dialogName) => state.dialog[dialogName] || { show: false };
